import { AgxFileUpload } from '@urbanx/agx-ui-components';
import {
  AgxButton,
  AgxDivider,
  AgxRadioGroup,
  AgxSpacer,
  AgxTypography,
} from '@urbanx/agx.ui-components2';
import Panel from 'components/panel/Panel';
import { useContext } from 'react';
import { AuthContext } from '@urbanx/agx.auth.client';
import { UploadedDocument, UploadedDocumentDocumentType } from '@urbanx/agx.campaigns.client';
import { getFileLink } from 'services';

interface ContractSectionProps {
  campaignId?: string | undefined;
  contractDocument?: UploadedDocument | undefined;
  pendingDelete: boolean;
  setPendingDelete: (value: boolean) => void;
  isFinalEnabled: boolean;
  isFinalSelected: boolean;
  setIsFinalSelected: (value: boolean) => void;
  setIsModalOpen: (value: boolean) => void;
}

const ContractSection = ({
  campaignId,
  contractDocument,
  pendingDelete,
  setPendingDelete,
  isFinalEnabled,
  isFinalSelected,
  setIsFinalSelected,
  setIsModalOpen,
}: ContractSectionProps) => {
  const { getAuthToken } = useContext(AuthContext);
  return (
    <AgxSpacer id="contract" direction="vertical" gap="spacing-xl" fill>
      <Panel
        title={
          <AgxTypography id="contractTitle" type="body" size="medium" color="var(--text-primary)">
            Contract
          </AgxTypography>
        }
        padding={{
          top: 'md',
          bottom: 'md',
          left: 'xl',
          right: 'xl',
        }}
      >
        <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
          {(!contractDocument || pendingDelete) && (
            <AgxSpacer direction="vertical" gap="spacing-lg" fill>
              <AgxTypography
                id="contractUploadLabel"
                type="label"
                size="medium"
                color="var(--text-primary)"
              >
                Contract
              </AgxTypography>
              <AgxButton
                id="contractUploadButton"
                dataTestId="btn-uploadContract"
                text="Choose file"
                variant="hollow"
                size="medium"
                onClick={() => setIsModalOpen(true)}
              />
            </AgxSpacer>
          )}

          {contractDocument && !pendingDelete && (
            <>
              <AgxSpacer direction="vertical" gap="spacing-md" fill>
                <AgxFileUpload
                  key={`ContractUpload-${contractDocument.documentId}`}
                  id="contractUpload"
                  title="Contract"
                  fileData={[contractDocument]}
                  campaignId={campaignId || ''}
                  documentType={UploadedDocumentDocumentType.BlankSalesContract}
                  getAuthToken={getAuthToken}
                  getFileLink={getFileLink}
                  onValueChanged={({ value }) => {
                    if (!value || value.length === 0) {
                      setPendingDelete(true);
                    }
                  }}
                  deleteFile={async () => {
                    return 1;
                  }}
                  extensions={['pdf']}
                  multiple={false}
                />
              </AgxSpacer>

              <AgxDivider variant="horizontal" />

              <AgxSpacer direction="vertical" gap="spacing-md" fill>
                <AgxRadioGroup
                  key={`ContractVersion-${isFinalSelected}`}
                  id="contractVersionSaved"
                  layout="stacked"
                  label="Contract version"
                  options={[
                    { label: 'Draft Contract', value: 'draft' },
                    {
                      label: 'Final Contract',
                      value: 'final',
                      disabled: !isFinalEnabled,
                      hint: !isFinalEnabled
                        ? 'To switch to the "Final Contract," please upload a new contract.'
                        : undefined,
                    },
                  ]}
                  value={isFinalSelected ? 'final' : 'draft'}
                  onChange={(value) => setIsFinalSelected(value === 'final')}
                />
              </AgxSpacer>
            </>
          )}
        </AgxSpacer>
      </Panel>
    </AgxSpacer>
  );
};

export default ContractSection;
